var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuDots(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13282",
    "data-name": "Group 13282",
    transform: "translate(-1728 -159)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11966",
    "data-name": "Group 11966",
    transform: "translate(1727.999 159)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_420",
    "data-name": "Ellipse 420",
    cx: 26,
    cy: 26,
    r: 26,
    transform: "translate(0.001)",
    fill: "#014fe0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12180",
    "data-name": "Group 12180",
    transform: "translate(1750.765 168.863)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45233",
    "data-name": "Path 45233",
    d: "M3.23,6.46A3.262,3.262,0,0,1,0,3.224,3.263,3.263,0,0,1,3.243,0,3.261,3.261,0,0,1,6.469,3.237,3.259,3.259,0,0,1,3.23,6.46",
    transform: "translate(-0.003 -0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45234",
    "data-name": "Path 45234",
    d: "M3.213,104.609a3.226,3.226,0,1,1,.047-6.453,3.226,3.226,0,1,1-.047,6.453",
    transform: "translate(-0.002 -85.242)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45235",
    "data-name": "Path 45235",
    d: "M3.24,202.773a3.222,3.222,0,1,1,3.226-3.23,3.25,3.25,0,0,1-3.226,3.23",
    transform: "translate(0 -170.498)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDots);
export default __webpack_public_path__ + "static/media/menu_dots.38bbc8b8e7d6f347599624ea7314f179.svg";
export { ForwardRef as ReactComponent };